export interface IUser {
  id: number;
  name: string;
  phone: string;
  email: string;
  city?: string;
  about?: string;
  birthdate?: Date;
  avatarLink: string;
  paid_status: boolean;
  /** Сохраняется на сервере при установке PWA / standalone */
  pwaInstalled?: boolean;
  User_AccountsRelation: ICoin[];
}

export interface ICoin {
  currency?: string;
  account_value?: number;
}

export interface IAnswer {
  id: number;
  passed: boolean;
  answer: string;
  date_complite: string;
  status_complite: boolean;
}

export interface IExercise {
  previwUrl: string;
  id: number;
  order: number;
  name_lesson: string;
  title_lesson: string;
  type_lesson: string;
  url: string;
  description: string;
  day: number;
  UserComplete_ExercisesRelation: IAnswer[];
}

export interface ILesson {
  id: number;
  section_id: number;
  sequence_number__lesson: number;
  title: string;
  round: number;
  Exercise_LessonRelation: IExercise[];
}

export interface IUserScheduled {
  id: number;
  start_date: string;
  round: number;
  SectionId: number;
  AchievementsRelation: IAchievements[];
}

export interface ISection {
  id: number;
  sequence_number__section: number;
  title: string;
  UserLessonsScheduled: IUserScheduled[];
  Lesson_SectionRelation: ILesson[];
}

export interface INew {
  Id: number;
  url: string;
}

export interface IStory {
  id: number;
  title: string;
  url: string;
  StorysViewedRelation: any[]; //for border
  News_IntoStorysRelation: INew[];
}

export interface IAchievements {
  id: number;
  typeAchievements: string;
  debugInfo: string;
}
export type TRewardType = 'Silver' | 'Pearl' | 'Gold' | 'miss coin';

export const TIME_HOURS_LS = 9;
export const TIME_MINUTE_LS = 0;